<template>
  <div class="chatbot-container">
    <ChatbotLanding />
  </div>
</template>

<script>
import ChatbotLanding from './components/ChatbotLanding.vue'

export default {
  name: 'Chatbot',
  components: { 
    ChatbotLanding
  },
  data() {
    return {
      // Landing page data
    }
  },
  mounted() {
    // Component mounted
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.chatbot-container {
  padding: 0;
}
</style>